export class TipoCirurgia {
  id: number;
  nome: string;
  observacao?: string;
  empresaId?: number;

  constructor(id = 0, nome = "", observacao = "", empresaId = 0) {
    this.id = id;
    this.nome = nome;
    this.observacao = observacao;
    this.empresaId = empresaId;
  }
}
